/** Query keys for the Bcc of sent messages, by office and message ids. Their
 *  own module so the cache persister can exclude them without importing the
 *  data hook. */
export const messageBccKeys = {
  all: ['email-message-bcc'] as const,
  byIds: (organizationId: string, messageIds: readonly string[]) =>
    [...messageBccKeys.all, organizationId, ...messageIds] as const,
};
